import { MatDatepickerIntl } from '@angular/material/datepicker';
import { Injectable } from '@angular/core';

@Injectable()
export class GermanDatepickerIntl extends MatDatepickerIntl {
    override openCalendarLabel = 'Kalender auswählen';
    override switchToMonthViewLabel = 'Monatsansicht wechseln';
    override switchToMultiYearViewLabel = 'Jahresansicht wechseln';

    override prevMonthLabel = 'Vorheriger Monat';
    override nextMonthLabel = 'Nächster Monat';
    override prevYearLabel = 'Vorheriges Jahr';
    override nextYearLabel = 'Nächstes Jahr';
    override prevMultiYearLabel = 'Vorherige Jahre';
    override nextMultiYearLabel = 'Nächsten Jahre';

    override closeCalendarLabel = 'Kalender schließen';
}
